import { render, staticRenderFns } from "./CRUDTurnos.vue?vue&type=template&id=3f93e3b8&"
import script from "./CRUDTurnos.vue?vue&type=script&lang=js&"
export * from "./CRUDTurnos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports